// extracted by mini-css-extract-plugin
module.exports = {"pageNavContainer":"PageNavigation-module--pageNavContainer--VYeSV","pageNav":"PageNavigation-module--pageNav--2bXje","backToTop":"PageNavigation-module--backToTop--2KWIs"};